import React, {useEffect} from 'react'
import clsx from 'clsx'
import {Paper} from '@material-ui/core'
import {useAppSelector, useAppDispatch} from 'store/redux'
import {isMobile} from 'react-device-detect'
import {loadStations} from 'store/actions/stations'
import Routes from 'modules/Routes'
import Loader from 'pages/Loader'

import useStyles from './styles'

const Main: React.FC = () => {
  const classes = useStyles()
  const dispatch = useAppDispatch()

  const isLoadingStations = useAppSelector(state => state.stations.isLoading)
  const isLoadedPermission = useAppSelector(state => state.account.isLoadedPermission)

  useEffect(() => {
    dispatch(loadStations())
  }, [dispatch])

  return (
    <Paper className={clsx(classes.root, {[classes.mobile]: isMobile})}>
      {isLoadingStations || !isLoadedPermission ? <Loader /> : <Routes />}
    </Paper>
  )
}

export default Main
